import * as React from "react";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import Footer from "../Footer";
import Toolbar from "@mui/material/Toolbar";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { styled } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { ChevronDown } from "react-feather";
import "./fundDetails.css";
import ArrowDownward from "@mui/icons-material/ArrowDropDown";
import Check from "@mui/icons-material/Check";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Clear from "@mui/icons-material/Clear";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import FilterList from "@mui/icons-material/FilterList";
import FirstPage from "@mui/icons-material/FirstPage";
import LastPage from "@mui/icons-material/LastPage";
import { FileText } from "react-feather";
import { headerActions } from "../../store/header";
import NewReportConfirmation from "../newReportConfirmation";
import questionnaireResponseService from "../../services/questionnaireResponse";
import moment from "moment";
import {
  questionnaireResponseStatus,
  PurchasedStatus,
  hasUnlimitedReportsIncluded,
} from "../../services/constants";
import { surveyIds } from "../../services/constants";
import FullDialog from "../MainBody/FullDialog/fullDialog";
import purchaseService from "../../services/purchase";
import documentService from "../../services/document";
import subscriptionService from "../../services/subscriptionPlan";
import { surveyActions } from "../../store/survey";
import productService from "../../services/product";
import ConfigContext from "../../context/ConfigContext";
import SubscriptionStatistics from "../SubscriptionStatistics";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
} from "@mui/material";

const tableIcons = {
  Check: React.forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: React.forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: React.forwardRef((props, ref) => (
    <DeleteOutline {...props} ref={ref} />
  )),
  DetailPanel: React.forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Filter: React.forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: React.forwardRef((props, ref) => (
    <FirstPage {...props} ref={ref} />
  )),
  LastPage: React.forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: React.forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  PreviousPage: React.forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  SortArrow: React.forwardRef((props, ref) => (
    <ArrowDownward {...props} ref={ref} />
  )),
};
const useStyles = makeStyles((theme) => ({
  createAccountBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "16px",
    width: "800px",
    height: "auto",
  },
  createAccountLbl: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "32px",
    color: "#000000",
    marginBlock: 0,
    marginBottom: 32,
  },
  textFieldLabel: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#000000",
    marginBlock: 0,
  },
  smallTextFieldLabel: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "9px",
    lineHeight: "16px",
    color: "#000000",
    letterSpacing: "0.1em",
  },
  red: {
    color: "red",
  },
  textField: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    background: "#ECEFF1",
    alignSelf: "stretch",
    height: "44px",
    paddingLeft: 8,
    paddingRight: 8,
  },
  text24: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "24px",
  },
  text14: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "24px",
  },
  textSummary: {
    padding: "0px 20px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
  },
  crossIcon: {
    position: "absolute",
    right: "24px",
    cursor: "pointer",
  },
  heading: {
    fontFamily: "Poppins",
    fontSize: "36px",
    lineHeight: "48px",
  },
  statusButton: {
    borderRadius: "50px",
    border: "0px",
    padding: "4px 16px",
    color: "#FFFFFF",
    fontFamily: "Poppins",
  },
}));

const CancelButton = styled(Button)({
  height: "44px",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "24px",
  background: "#FFFFFF",
  border: "1px solid #1A2842",
  boxSizing: "border-box",
  color: "#1A2842",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  borderRadius: "5px",
  fontFamily: ["Poppins"].join(","),
  "&:hover": {
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  "&:active": {
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#FFFFFF",
  },
  "&:focus": {
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
});
const ActionButton = styled(Button)({
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "24px",
  color: "#1A2842",
  textDecoration: "underline",
  fontFamily: "Poppins",
});

const CreateReportButton = styled(Button)({
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  textTransform: "none",
  fontSize: "14px",
  padding: "10px 20px",
  border: "none",
  fontWeight: 400,
  lineHeight: "24px",
  backgroundColor: "#1A2842",
  color: "white",
  fontFamily: ["Poppins"].join(","),
  "&:hover": {
    backgroundColor: "#1A2842",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  "&:active": {
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#1A2842",
  },
  "&:focus": {
    backgroundColor: "#1A2842",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  "&:disabled": {
    color: "white",
    backgroundColor: "#8C94A0;",
  },
});
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderBottom: "1px solid #D1D4D9",
  // '&:not(:last-child)': {
  //   borderBottom: 0,
  // },
  "&:before": {},
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary expandIcon={<ChevronDown size={24} />} {...props} />
))(({ theme }) => ({
  padding: "8px",
  minHeight: "auto",
  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(1),
  borderTop: "1px solid #D1D4D9",
}));

export default function BGLFundDetails() {
  const MAX_EDITS = 3;
  const config = React.useContext(ConfigContext);
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const isUserLoggedIn = useSelector((state) => state.auth.loggedIn);
  const user = useSelector((state) => state.auth.user);
  const selectedFund = useSelector((state) => state.header.selectedFund);
  const isReportBtnDisabled = useSelector(
    (state) => state.header.isReportBtnDisabled
  );
  const openSMSFCheckup = useSelector((state) => state.survey.openSurveyForm);
  const openNewReportConfirmation = useSelector(
    (state) => state.header.openNewReportConfirmation
  );
  const [fundsActivityList, setFundsActivityList] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(500);
  const [nextToken, setNextToken] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const reportBtnText = useSelector((state) => state.header.reportBtnText);
  const [isReportInProgress, setIsReportInProgress] = React.useState(false);
  const selectedProduct = JSON.parse(localStorage.getItem("selectedProduct"));
  const [viewResponseMode, setViewResponseMode] = React.useState(false);
  const [editResponseMode, setEditResponseMode] = React.useState(false);
  const [selectedQuestionnaireResponse, setSelectedQuestionnaireResponse] =
    React.useState(null);
  const [isNewPlan, setIsNewPlan] = React.useState(false);
  const [stripeData, setstripeData] = React.useState(null);
  const [hasSubscription, setHasSubscription] = React.useState(null);
  const [extraReportPrice, setExtraReportPrice] = React.useState(null);

  const [usedReportsCount, setUsedReportsCount] = React.useState(0);
  const [subscriptionDetails, setSubscriptionDetails] = React.useState(null);
  const [isLoadingSubscriptionData, setIsLoadingSubscriptionData] =
    React.useState(false);
  const [reportStatics, setReportStatics] = React.useState(null);

  const [page, setPage] = React.useState(0);

  let maxYear = 2022; //UNCOMMENT WHEN P4 IS COMPLETED new Date().getMonth() > 6 ? new Date().getFullYear() : new Date().getFullYear() - 1;
  const getExtraReportProductId = () => config?.extraReportProductId;

  React.useEffect(() => {
    if (
      !(
        selectedProduct &&
        selectedProduct.id &&
        selectedFund &&
        selectedFund.fundID
      )
    ) {
      window.location.href = "/";
    }
  }, [selectedProduct, selectedFund]);

  React.useEffect(() => {
    async function fetchData() {
      try {
        setIsLoading(true);
        questionnaireResponseService
          .getAllQuestionnaireResponseByFund(
            selectedFund.fundID,
            rowsPerPage,
            nextToken
          )
          .then(async (result) => {
            setNextToken(result.nextToken);
            const responseStatus = result?.items?.some((reponse) => {
              return reponse.status === questionnaireResponseStatus.INPROGRESS;
            });
            if (responseStatus) {
              dispatch(
                headerActions.handleReportBtnText({
                  btnText: "Continue Report",
                })
              );
              setIsReportInProgress(true);
            } else {
              purchaseService
                .getPurchaseByStatus(PurchasedStatus.pending)
                .then((result) => {
                  if (
                    result.length &&
                    result.find((item) => item.fundId === selectedFund.fundID)
                  ) {
                    dispatch(
                      headerActions.handleReportBtnText({
                        btnText: "Continue Report",
                      })
                    );
                    setIsReportInProgress(true);
                  } else {
                    dispatch(
                      headerActions.handleReportBtnText({
                        btnText: "Create new Report",
                      })
                    );
                  }
                });
            }
            const data = result?.items.sort((a, b) => {
              return new Date(b.updatedAt) - new Date(a.updatedAt);
            });
            for (let item of data) {
              await purchaseService
                .getPurchaseByQuestionnaireResponseId(item.id)
                .then((purchaseRecord) => {
                  item.edits = purchaseRecord?.[0]?.edits || 1; //if no data set to 1 to match new report logic (3 edits max, 1 used upon first completion)
                });
            }
            setFundsActivityList(data);
          });
        setIsLoading(false);
      } catch (error) {
        console.log("error", error);
      }
      await fetchSubscriptionData();
    }
    fetchData();
  }, []);

  async function fetchSubscriptionData() {
    try {
      setIsLoadingSubscriptionData(true);

      await getAndSetExtraReportPrice();

      // get report info
      const reportInfoRes = await purchaseService.getReportInfo({});
      const reportInfo = JSON.parse(reportInfoRes);
      console.log("get report info ----------------", reportInfo);

      if (
        reportInfo &&
        reportInfo.statusCode === 200 &&
        reportInfo?.body?.reports
      ) {
        setReportStatics(reportInfo.body.reports);
      }

      const [currentPlan, usedReports, extraReports] =
        await purchaseService.getCurrentPlanAndUsedReportsBySub(user.sub);
      setstripeData(JSON.parse(currentPlan.stripeData));
      const hasSubscription = currentPlan?.expiryDate > new Date().getTime();
      setHasSubscription(hasSubscription);
      setUsedReportsCount(usedReports?.length || 0);

      const planId = currentPlan?.product?.planId;
      const s = await subscriptionService.getSubscriptionPlan(planId);
      setSubscriptionDetails({
        ...s,
        extraReports,
      });
      setIsNewPlan(s.status === "active" ? true : false);
    } catch (e) {
      // TODO: notify user
    } finally {
      setIsLoadingSubscriptionData(false);
    }
  }

  async function getAndSetExtraReportPrice() {
    const extraReportProduct = await productService.getProductById(
      getExtraReportProductId()
    );
    setExtraReportPrice(extraReportProduct?.priceBase);
  }

  const getExtraReports = () => {
    return subscriptionDetails?.extraReports;
  };

  const getRemainingExtraReports = () => {
    return getExtraReports()?.length || 0;
  };

  const getTotalReports = () => subscriptionDetails?.reportsIncluded;

  const _hasUnlimitedReportsIncluded = hasUnlimitedReportsIncluded(
    getTotalReports()
  );

  const handleCancel = () => {
    history.push("/fundsList");
  };
  const handleCreateReport = () => {
    localStorage.setItem("noOfReports", "null");
    if (isReportInProgress) {
      // setOpenSMSFCheckup(true);
      dispatch(surveyActions.handleOpenSurveyForm(true));
      setViewResponseMode(false);
      setSelectedQuestionnaireResponse(null);
    } else {
      dispatch(headerActions.handleOpenNewReportConfirmation());
    }
  };

  const onViewReport = async (questionnaireResponse) => {
    const documentsSub = await documentService.getDocumentByQRId(
      questionnaireResponse?.id
    );
    if (documentsSub) {
      const pdfDocument = documentsSub?.find((item) =>
        item?.documentLocation?.endsWith(".pdf")
      );
      const htmlDocument = documentsSub?.find((item) =>
        item?.documentLocation?.endsWith(".html")
      );
      dispatch(headerActions.setPdfDocument({ pdfDocument }));
      dispatch(headerActions.setHtmlDocument({ htmlDocument }));
    }
    dispatch(headerActions.handleOpenViewReportMode());
    dispatch(
      headerActions.setSelectedProduct({ selectedProduct: selectedProduct })
    );
    dispatch(
      headerActions.setOpenHtmlReportViewer({ openHtmlReportViewer: true })
    );
  };

  const onViewResponse = async (questionnaireResponse) => {
    setViewResponseMode(true);
    dispatch(surveyActions.handleOpenSurveyForm(true));
    setSelectedQuestionnaireResponse(questionnaireResponse);
  };

  const onAmendResponse = async (questionnaireResponse) => {
    const documentsSub = await documentService.getDocumentByQRId(
      questionnaireResponse?.id
    );
    localStorage.setItem("noOfReports", JSON.stringify(documentsSub.length));
    setEditResponseMode(true);
    dispatch(surveyActions.handleOpenSurveyForm(true));
    setSelectedQuestionnaireResponse(questionnaireResponse);
  };
  const onClose = () => {
    setViewResponseMode(false);
    setSelectedQuestionnaireResponse(null);
    dispatch(surveyActions.handleCloseSurveyForm(true));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      {isUserLoggedIn && user && user.email && user?.bglIsValid && (
        <Box
          style={{ background: "#FAFAFA" }}
          sx={{ padding: "106px 32px", width: "100%", pb: 0 }}
        >
          <Grid>
            <Box
              variant="small"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <CancelButton
                  variant="contained"
                  onClick={() => handleCancel(false)}
                >
                  <ArrowBackIosIcon
                    style={{ fontSize: "14px", marginRight: "2px" }}
                  />
                  Back to funds list
                </CancelButton>
              </div>

              <div>
                {isLoadingSubscriptionData ? (
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ mt: 2 }}
                  >
                    <CircularProgress />
                  </Grid>
                ) : (
                  hasSubscription && (
                    <Grid container>
                      {/* {!_hasUnlimitedReportsIncluded && (
                        <Grid item>
                          <Box sx={{ width: 200, marginTop: "2px" }}>
                            <SubscriptionStatistics
                              totalReportsCount={getTotalReports()}
                              usedReportsCount={usedReportsCount}
                              extraReportsCount={getRemainingExtraReports()}
                            />
                          </Box>
                        </Grid>
                      )} */}

                      {!(isNewPlan && reportStatics?.unlimited) ? (
                        <Grid item>
                          <Box sx={{ width: 200, marginTop: "2px" }}>
                            <SubscriptionStatistics
                              // totalReportsCount={getTotalReports()}
                              // usedReportsCount={usedReportsCount}
                              // extraReportsCount={getRemainingExtraReports()}
                              totalReportsCount={
                                reportStatics
                                  ? reportStatics.total +
                                    reportStatics.carryForward
                                  : 0
                              }
                              usedReportsCount={
                                reportStatics ? reportStatics.used : 0
                              }
                              extraReportsCount={
                                reportStatics ? reportStatics.extra : 0
                              }
                              isNewPlan={isNewPlan}
                            />
                          </Box>
                        </Grid>
                      ) : null}

                      {/* {isNewPlan ? (
                        <Grid item>
                          <Box sx={{ width: 200, marginTop: "2px" }}>
                            <SubscriptionStatistics
                              totalReportsCount={stripeData?.quantity}
                              usedReportsCount={usedReportsCount}
                              extraReportsCount={getRemainingExtraReports()}
                              isNewPlan={isNewPlan}
                            />
                          </Box>
                        </Grid>
                      ) : (
                        <Grid item>
                          <Box sx={{ width: 200, marginTop: "2px" }}>
                            <SubscriptionStatistics
                              totalReportsCount={getTotalReports()}
                              usedReportsCount={usedReportsCount}
                              extraReportsCount={getRemainingExtraReports()}
                              isNewPlan={isNewPlan}
                            />
                          </Box>
                        </Grid>
                      )} */}

                      <Grid item ml={4}>
                        <CreateReportButton
                          variant="contained"
                          disabled={isReportBtnDisabled}
                          onClick={() => handleCreateReport()}
                        >
                          {reportBtnText}
                          <FileText
                            style={{
                              fontSize: "18px",
                              marginLeft: "4px",
                              width: "14px",
                            }}
                          />
                        </CreateReportButton>
                      </Grid>
                    </Grid>
                  )
                )}
              </div>
            </Box>
          </Grid>
          <Grid mt={6}>
            <Typography className={classes.heading}>
              {selectedFund.fundName}
            </Typography>
          </Grid>
          <Grid mt={2}>
            <Typography className={classes.text14}>Fund Summary</Typography>
            <Box variant="small" mt={3}>
              <table>
                <tr>
                  <td>
                    <Typography
                      className={classes.textSummary}
                      style={{ fontWeight: "700" }}
                    >
                      Fund Code
                    </Typography>
                    <Typography mt={0} className={classes.textSummary}>
                      {selectedFund.fundCode}
                    </Typography>
                  </td>
                  <td>
                    <Typography
                      className={classes.textSummary}
                      style={{ fontWeight: "700" }}
                    >
                      Fund Name
                    </Typography>
                    <Typography mt={0} className={classes.textSummary}>
                      {selectedFund.fundName}
                    </Typography>
                  </td>
                  <td>
                    <Typography
                      className={classes.textSummary}
                      style={{ fontWeight: "700" }}
                    >
                      Email Address
                    </Typography>
                    <Typography
                      mt={0}
                      className={classes.textSummary}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {selectedFund.fundEmail}
                    </Typography>
                  </td>
                  <td>
                    <Typography
                      className={classes.textSummary}
                      style={{ fontWeight: "700" }}
                    >
                      ABN
                    </Typography>
                    <Typography mt={0} className={classes.textSummary}>
                      {selectedFund.ABN}
                    </Typography>
                  </td>
                </tr>
              </table>
            </Box>
          </Grid>
          {selectedFund?.members && (
            <Grid mt={5}>
              <Typography className={classes.text14}>Fund Members</Typography>
              {selectedFund?.members?.map((memberDetail, index) => {
                return (
                  <>
                    <Box>
                      <Accordion style={{ background: "#FAFAFA" }}>
                        <AccordionSummary
                          aria-controls="panel2d-content"
                          id="panel2d-header"
                        >
                          <Typography variant="big">
                            {memberDetail.firstName +
                              " " +
                              memberDetail.lastName}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box className={classes.createAccountBox}>
                            <Grid container spacing={6}></Grid>
                          </Box>
                          <Grid item xs={12}>
                            <Box mb={3}>
                              <table style={{ width: "100%" }}>
                                <tr>
                                  <td>
                                    <Typography
                                      className={classes.textSummary}
                                      style={{ fontWeight: "700" }}
                                    >
                                      Title
                                    </Typography>
                                    <Typography
                                      mt={0}
                                      className={classes.textSummary}
                                    >
                                      {memberDetail.gender === "Male"
                                        ? "Mr"
                                        : memberDetail.gender === "Female"
                                        ? "Ms"
                                        : memberDetail.title}
                                    </Typography>
                                  </td>
                                  <td>
                                    <Typography
                                      className={classes.textSummary}
                                      style={{
                                        fontWeight: "700",
                                        width: "25%",
                                      }}
                                    >
                                      Gender
                                    </Typography>
                                    <Typography
                                      mt={0}
                                      className={classes.textSummary}
                                    >
                                      {memberDetail.gender}
                                    </Typography>
                                  </td>
                                  <td>
                                    <Typography
                                      className={classes.textSummary}
                                      style={{
                                        fontWeight: "700",
                                        width: "25%",
                                      }}
                                    >
                                      Street
                                    </Typography>
                                    <Typography
                                      mt={0}
                                      className={classes.textSummary}
                                    >
                                      {memberDetail.address.streetLine1}
                                      <br /> {memberDetail.address.streetLine2}
                                    </Typography>
                                  </td>
                                  <td>
                                    <Typography
                                      className={classes.textSummary}
                                      style={{
                                        fontWeight: "700",
                                        width: "25%",
                                      }}
                                    >
                                      Country
                                    </Typography>
                                    <Typography
                                      mt={0}
                                      className={classes.textSummary}
                                    >
                                      {memberDetail.address.country === "AU"
                                        ? "Australia"
                                        : memberDetail.address.country}
                                    </Typography>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <Typography
                                      className={classes.textSummary}
                                      style={{ fontWeight: "700" }}
                                    >
                                      First Name
                                    </Typography>
                                    <Typography
                                      mt={0}
                                      className={classes.textSummary}
                                    >
                                      {memberDetail.firstName}
                                    </Typography>
                                  </td>
                                  <td>
                                    <Typography
                                      className={classes.textSummary}
                                      style={{ fontWeight: "700" }}
                                    >
                                      Date of Birth
                                    </Typography>
                                    <Typography
                                      mt={0}
                                      className={classes.textSummary}
                                    >
                                      {moment(memberDetail.dob).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </Typography>
                                  </td>
                                  <td>
                                    <Typography
                                      className={classes.textSummary}
                                      style={{ fontWeight: "700" }}
                                    >
                                      City
                                    </Typography>
                                    <Typography
                                      mt={0}
                                      className={classes.textSummary}
                                    >
                                      {memberDetail.address.city}
                                    </Typography>
                                  </td>
                                  <td>
                                    <Typography
                                      className={classes.textSummary}
                                      style={{ fontWeight: "700" }}
                                    >
                                      Postcode
                                    </Typography>
                                    <Typography
                                      mt={0}
                                      className={classes.textSummary}
                                    >
                                      {memberDetail.address.postCode}
                                    </Typography>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <Typography
                                      className={classes.textSummary}
                                      style={{ fontWeight: "700" }}
                                    >
                                      Last Name
                                    </Typography>
                                    <Typography
                                      mt={0}
                                      className={classes.textSummary}
                                    >
                                      {memberDetail.lastName}
                                    </Typography>
                                  </td>
                                  <td>
                                    <Typography
                                      className={classes.textSummary}
                                      style={{ fontWeight: "700" }}
                                    >
                                      Email
                                    </Typography>
                                    <Typography
                                      mt={0}
                                      className={classes.textSummary}
                                    >
                                      {memberDetail.email}
                                    </Typography>
                                  </td>
                                  <td>
                                    <Typography
                                      className={classes.textSummary}
                                      style={{ fontWeight: "700" }}
                                    >
                                      State
                                    </Typography>
                                    <Typography
                                      mt={0}
                                      className={classes.textSummary}
                                    >
                                      {memberDetail.address.state}
                                    </Typography>
                                  </td>
                                </tr>
                              </table>
                            </Box>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  </>
                );
              })}
            </Grid>
          )}
          <Grid mt={8}>
            <Typography className={classes.heading}>Fund Activity</Typography>
            <TableContainer sx={{ marginTop: "15px" }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#FFFFFF" }}>
                    {[
                      "Product Name",
                      "Created By",
                      "Survey Status",
                      "Report Status",
                      "Date Created",
                      "Action",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          fontWeight: "700",
                          borderTop: "1px solid #C1C1C1",
                          padding: "15px 10px",
                          ...(header === "Created By" && { width: "350px" }),
                          ...((header === "Survey Status" ||
                            header === "Report Status") && { width: "200px" }),
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fundsActivityList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={row.productType}
                        sx={{
                          backgroundColor: index % 2 ? "#F2F3F3" : "#FFFFFF",
                        }}
                      >
                        <TableCell>
                          {row.type === "SMSF001" ? "SMSF Check Up" : row.type}
                        </TableCell>
                        <TableCell>
                          {row.createdBy ? (
                            <>
                              {row.createdBy} <br /> ({row.email})
                            </>
                          ) : (
                            row.email
                          )}
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor:
                                row.status === "FAILED"
                                  ? "#EC0018"
                                  : row.status === "COMPLETE"
                                  ? "#2AD000"
                                  : "#0099FF",
                              borderRadius: "50px",
                            }}
                          >
                            {row.status === "FAILED"
                              ? "Failed"
                              : row.status === "COMPLETE"
                              ? "Completed"
                              : "In Progress"}
                          </Button>
                        </TableCell>
                        <TableCell>
                          {row.status === "COMPLETE" ? (
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "#2AD000",
                                borderRadius: "50px",
                              }}
                            >
                              Completed
                            </Button>
                          ) : (
                            " "
                          )}
                        </TableCell>
                        <TableCell>
                          {moment(row.createdAt).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell>
                          {row.status === "COMPLETE" && (
                            <div>
                              {row.edits < MAX_EDITS && (
                                <Button onClick={() => onAmendResponse(row)}>
                                  Amend Report ({MAX_EDITS - row.edits} edit
                                  {MAX_EDITS - row.edits > 1 ? "s" : ""} left)
                                </Button>
                              )}
                              <Button onClick={() => onViewResponse(row)}>
                                View Responses
                              </Button>
                              <Button onClick={() => onViewReport(row)}>
                                View Report
                              </Button>
                            </div>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 20, 25, 50]}
              component="div"
              count={fundsActivityList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
          <Toolbar />
          <Footer />
        </Box>
      )}
      {isUserLoggedIn && selectedProduct.surveyId === surveyIds.SMSF001 && (
        <FullDialog
          productSurveyId={surveyIds.SMSF001}
          product={selectedProduct}
          open={openSMSFCheckup}
          viewResponseMode={viewResponseMode}
          editResponseMode={editResponseMode}
          selectedQuestionnaire={selectedQuestionnaireResponse}
          closeSurvey={() => onClose()}
        />
      )}
      {isUserLoggedIn && selectedProduct.surveyId === "TEST001" && (
        <FullDialog
          productSurveyId={"TEST001"}
          product={selectedProduct}
          open={openSMSFCheckup}
          viewResponseMode={viewResponseMode}
          editResponseMode={editResponseMode}
          selectedQuestionnaire={selectedQuestionnaireResponse}
          closeSurvey={() => onClose()}
        />
      )}
      {openNewReportConfirmation && (
        <NewReportConfirmation
          // usedReportsCount={usedReportsCount}
          // totalReportsCount={getTotalReports()}
          // extraReports={getExtraReports()}
          extraReportsList={getExtraReports()}
          usedReportsCount={reportStatics?.used || 0}
          totalReportsCount={
            reportStatics ? reportStatics.total + reportStatics.carryForward : 0
          }
          extraReports={reportStatics?.extra || 0}
          // stripeData={stripeData}
          isNewPlan={isNewPlan}
          extraReportPrice={extraReportPrice}
          maxYear={maxYear}
          product={selectedProduct}
          fundID={selectedFund.fundID}
          reportStatics={reportStatics}
        />
      )}
    </>
  );
}
